module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-700.4bc0bd04.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-700.woff2
// module id = 482
// module chunks = 0